import React, { useEffect, useState } from 'react';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import styles from './ProductSortSelection.module.scss';

const CustomToggle = React.forwardRef(
  ({ 'aria-expanded': ariaExpanded, selectedSort, onClick }, ref) => {
    const [isExpanded, setIsExpanded] = useState(false);

    useEffect(() => {
      if (ariaExpanded) {
        setIsExpanded(true);
      } else {
        setIsExpanded(false);
      }
    }, [ariaExpanded, setIsExpanded]);

    const label = `Current sort is ${selectedSort?.label}`;

    return (
      <button
        ref={ref}
        aria-label={label}
        type="button"
        className={classNames(
          'font-roboto fs-8 text-primary bg-transparent text-left w-100 btn border-2 border-primary my-auto',
          styles.h44,
          styles.button
        )}
        onClick={(e) => {
          e.preventDefault();
          onClick(e);
        }}
      >
        <div className="w-100">
          <span className="me-6">
            <span className={styles.label}>{selectedSort?.label}</span>
          </span>
          <span className={classNames(styles.floatRight)}>
            <span
              className={classNames('d-inline-block', styles.chevron_wrapper)}
            >
              <FontAwesomeIcon
                className={classNames(styles.chevron, {
                  [styles.active]: isExpanded,
                })}
                icon={faChevronDown}
              />
            </span>
          </span>
        </div>
      </button>
    );
  }
);

export default CustomToggle;
